const version = {
  major: 4,
  minor: 0,
  patch: 0
};
export {
  version
};
//# sourceMappingURL=versions.js.map
